// Bắt tham số truy vết nguồn (utm/fbclid/zalo/referrer) — first-touch: giữ lần chạm đầu.
const KEY = 'lead_tracking'
const PARAMS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
  'fbclid', 'gclid', 'ttclid', 'zarsrc', 'gidzl',
]

export function captureTracking() {
  try {
    if (sessionStorage.getItem(KEY)) return   // đã bắt lần đầu -> giữ nguyên
    const q = new URLSearchParams(window.location.search)
    const t = {}
    PARAMS.forEach((k) => { const v = q.get(k); if (v) t[k] = v })
    const ref = document.referrer || ''
    if (ref) t.referrer = ref
    if (Object.keys(t).length) sessionStorage.setItem(KEY, JSON.stringify(t))
  } catch { /* ignore */ }
}

export function getTracking() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null') } catch { return null }
}
